import { useLocation } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

export const addFromParameter = (path: string, pathname: string): string => {
  const separator = path.includes('?') ? '&' : '?'
  return `${path}${separator}from=${pathname}`
}

export const useMarketplaceModulesPath = () => {
  const { navigation } = useNavigation()
  const location = useLocation()

  const getListPath = (additionalParams?: string, includeAll = false): string => {
    let basePath = navigation.discover.marketplaceModules.fullPath()
    if (includeAll) {
      basePath = `${basePath}/all`
    }
    const pathWithParams = additionalParams
      ? `${basePath}${basePath.includes('?') ? '&' : '?'}${additionalParams}`
      : basePath
    return addFromParameter(pathWithParams, location.pathname)
  }

  const getDetailPath = (slug: string, additionalParams?: string): string => {
    const basePath = navigation.discover.marketplaceModules.item.fullPath({ id: slug })
    const pathWithParams = additionalParams
      ? `${basePath}${basePath.includes('?') ? '&' : '?'}${additionalParams}`
      : basePath
    return addFromParameter(pathWithParams, location.pathname)
  }

  return {
    getListPath,
    getDetailPath,
    addFromParameter,
  }
}
